

const NoData = ({ size }) => {

    return (
        <img
            src={require("../../assets/images/noData.png")}
            width={size}
            alt=" "
        />
    )
}


export default NoData;